import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProviderGroupState {
  id: string;
  name: string;
  isActive: boolean;
  props: {
    [key: string]: any;
  };
}

const initialState: ProviderGroupState = {
  id: '',
  name: '',
  isActive: false,
  props: { isModalVisible: false, refresh: false, searchTerm: '', skip: 1, take: 10, totalItems: 0 },
};

const providerGroupSlice = createSlice({
  name: 'providerGroup',
  initialState,
  reducers: {
    setProviderGroup: (state, action: PayloadAction<Partial<ProviderGroupState>>) => {
      return { ...state, ...action.payload };
    },

    resetProviderGroup: (_state, action: PayloadAction<Partial<ProviderGroupState['props']> | undefined>) => {
      return {
        ...initialState,
        props: { ...initialState.props, ...action.payload },
      };
    },

    updateField: (state: ProviderGroupState, action: PayloadAction<{ field: any; value: any }>) => {
      const { field, value } = action.payload;
      (state as any)[field] = value;
    },

    updateProps: (state, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.props = {
        ...state.props,
        [field]: value,
      };
    },
  },
});

export const { setProviderGroup, resetProviderGroup, updateField, updateProps } = providerGroupSlice.actions;

export default providerGroupSlice.reducer;
